import { render } from "./CircularHelpMenuComp.vue?vue&type=template&id=5cbefdf5&scoped=true"
import script from "./CircularHelpMenuComp.vue?vue&type=script&lang=js"
export * from "./CircularHelpMenuComp.vue?vue&type=script&lang=js"

import "./CircularHelpMenuComp.vue?vue&type=style&index=0&id=5cbefdf5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbefdf5"]])

export default __exports__